// Module
var code = "<svg height=11 viewBox=\"0 0 11 11\" width=11 xmlns=http://www.w3.org/2000/svg><g fill=none fill-rule=evenodd stroke=#000><path d=\"m1 1 9 9\"/><path d=\"m10 1-9 9\"/></g></svg>";
// Exports
module.exports = code;